<template>
  <f7-page
    :theme-dark="dark"
    no-navbar
    id="map"
    @page:beforein="pageAfterIn"
    @page:beforeout="pageBeforeOut"
    @page:beforeremove="pageBeforeRemove"
  >

    <f7-fab
      position="right-top"
      slot="fixed"
      :color="dark ? 'black' : 'white'"
      style="margin-top:0"
      class="quick-action-fab"
    >
      <FlatIcon
        name="menu"
        :size="32"
      />
      <f7-fab-buttons position="bottom">
        <f7-fab-button
          fab-close
          :label="t('search')"
          href="/search"
        >
          <FlatIcon
            name="search"
            :size="20"
          />
        </f7-fab-button>
        <f7-fab-button
          fab-close
          :label="t('settings')"
          href="/settings"
        >
          <FlatIcon
            name="gear"
            :size="24"
          />
        </f7-fab-button>
      </f7-fab-buttons>
    </f7-fab>

    <!-- <f7-fab
      v-if="loading"
      position="left-top"
      slot="fixed"
      :color="dark ? 'black' : 'white'"
      style="margin-top:0">
      <AtlasLoading :size="50" />
    </f7-fab> -->

    <LeafletMap
      ref="map"
      :height="mapHeight"
      :full="!opened"
      @openSheet="openSheet"
      @closeSheet="closeSheet"
    />

    <f7-sheet
      ref="sheet"
      :opened="visible"
      :class="{ 'theme-dark': dark }"
      :closeByBackdropClick="false"
      :closeByOutsideClick="false"
      swipeHandler=".sheet-modal-swipe-step"
      swipe-to-step
      style="height:auto;"
      class="map-sheet"
      @sheet:stepprogress="sheetProgress"
    >
      <div class="sheet-modal-swipe-step">
        <MapFooter
          :opened="opened"
          @bbox="bbox"
          @discover="discover"
          @closeSheet="closeSheet"
        />
      </div>

      <div
        style="height:250px;"
        :style="{ background: dark ? 'black' : 'white' }"
      >
        <MarkersSwiper
          v-if="visible"
          @closeSheet="closeSheet"
        />
      </div>
    </f7-sheet>

  </f7-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MapFooter from '@/components/hl/MapFooter'
import LeafletMap from '@/components/io/LeafletMap'
import MarkersSwiper from '@/components/hl/MarkersSwiper'

export default {
  name: 'Map',
  components: {
    MapFooter,
    MarkersSwiper,
    LeafletMap
  },
  data () {
    return {
      visible: false, // sheet modal buttons and footer visible
      opened: false, // sheet opened
      sheetHeight: 260, // body of sheet
      sheetPct: 0 // percentage of sheet step opened
    }
  },
  computed: {
    ...mapGetters({
      markers: 'global/markers',
      swiper: 'global/swiper',
      markerSpeech: 'speech/markerSpeech',
      highlight: 'global/highlight'
    }),
    height () {
      return this.$parent && this.$parent.$el ? this.$parent.$el.offsetHeight : 0
    },
    mapHeight () {
      const h = this.height
      return this.opened ? h - 200 - 60 + 20 : window.innerHeight - 60 + 20
    }
  },
  watch: {
    sheetPct (val, old) {
      if (val === 1) this.opened = true
      if (val < old) this.opened = false
    },
    mapHeight () {
      this.$nextTick(() => {
        this.$refs.map.invalidateSize({ debounceMoveend: true })
      })
    }
  },
  methods: {
    ...mapActions({
      setSwiper: 'global/setSwiper',
      setHighlight: 'global/setHighlight'
    }),
    play (e) {
      // console.log(e)
    },
    route (e) {
      // console.log(e)
    },
    discover () {
      this.$refs.map.clickMarker()
    },
    bbox (bbox) {
      // this.openSheet()
      // this.$nextTick(() => {
      //   this.$refs.map.fitBbox(bbox)
      // })
      // console.log(bbox)
      this.$refs.map.fitBbox(bbox)
    },
    sheetProgress (sheet, progress) {
      this.sheetPct = progress
    },
    openSheet () {
      this.$refs.sheet.f7Sheet.stepOpen(true)
      this.sheetPct = 1
    },
    closeSheet () {
      this.$refs.sheet.f7Sheet.stepClose(true)
      this.sheetPct = 0
    },
    pageAfterIn () {
      this.sheetPct = 0
      this.visible = true
    },
    pageBeforeOut () {
      this.sheetPct = 0
      this.visible = false
      this.$nextTick(() => {
        this.$refs.map.invalidateSize()
      })
    },
    pageBeforeRemove () {
      this.sheetPct = 0
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.map-sheet {
  height: auto;
  background: none !important;
  &:before {
    display: none !important;
  }
  .sheet-modal-inner {
    overflow: visible !important;
  }
}
.map-sheet-step {
  height: 140px;
  text-align: center;
}
.playlist-container {
  height: 175px;
}
.chips .player-footer {
  padding-top: 15px;
}
.player-footer .inactive {
  width: inherit;
  text-align: center;
  color: #26addf;
  font-family: auto;

  hr {
    border: 3px solid gray;
    border-radius: 5px;
    width: 100px;
    opacity: 0.3;
  }
}
.markerActions {
  .title {
    width: 100%;
    text-align: center;
    font-family: "Aleo";
    font-size: 1em;
    font-weight: bold;
  }
  .buttons {
    width: 100%;
    margin-top: 0.5em;
    display: flex;
    justify-content: center;

    a {
      margin: 0em 0.5em;
      border-width: 1px;
      text-transform: none;
    }
  }
}
#map {
  .fab.color-black a {
    background: #222;
  }
  .page-content {
    overflow: hidden;
  }
}
.dark {
  .fab-label {
    background: #222;
    color: white;
  }
}
.quick-action-fab {
  .fab-label {
    pointer-events: auto;
  }
}
</style>

<docs>
```js
<Map />
```
</docs>
